// Copyright (c) 2016 Deere & Company

import FailurePanelContainer from './failure-panel-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    formValidation: state.claims.massChannelPdi.formValidation,
    isDuplicateClaim: state.claims.massChannelPdi.claim.isDuplicateClaim,
    isEditable: state.claims.massChannelPdi.isEditable,
    isValidClaim: state.claims.massChannelPdi.isValidClaim,
    pins: state.claims.massChannelPdi.claim.pins
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(FailurePanelContainer);



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-pdi/components/failure-panel/index.js